// Blog post: Solar Installation Arcadia CA
// Target keyword: Solar Installation Arcadia CA

const post = {
  slug: "solar-installation-arcadia",
  category: "Solar · Arcadia",
  title: "Solar Panel Installation in Arcadia, CA — What Homeowners Need to Know",
  summary:
    "How Arcadia homeowners can go solar, understand local incentives, find a licensed installer, and avoid common mistakes before signing.",
  readTime: "5 min read",
  sections: [
    {
      heading: "Why Arcadia is a great market for solar",
      body: "Arcadia sits in the San Gabriel Valley with strong sun exposure and high electricity costs through SCE. Homeowners in Arcadia with larger properties — including the estates near the Santa Anita area — often have ideal roof space and usage patterns for solar. A well-sized solar installation in Arcadia CA can cut monthly bills significantly and increase property value.",
    },
    {
      heading: "Step 1: Know your incentives",
      body: "California homeowners can apply the federal Investment Tax Credit (ITC) to their solar installation cost. SCE customers in Arcadia also benefit from net metering — credits for excess power you send back to the grid. Some Arcadia HOAs have specific rules about solar aesthetics, so check your HOA guidelines before going to contract.",
    },
    {
      heading: "Step 2: Verify the installer's license",
      body: "Solar installers in California must hold a C-10 (electrical) or C-46 (solar) license from the CSLB. Verify at cslb.ca.gov. NABCEP certification is the gold standard for solar professionals — ask if the lead installer on your project holds it.",
    },
    {
      heading: "Step 3: Review project details and next steps carefully",
      body: "Quotes should include system size in kW, panel brand and efficiency, inverter type, estimated annual production, total cost before and after incentives, and warranty terms. A solar installation in Arcadia CA should come with at least a 10-year workmanship warranty and 25-year panel performance warranty from the manufacturer.",
    },
    {
      heading: "Step 4: Watch out for HOA restrictions",
      body: "Many Arcadia neighborhoods have active HOAs, some with design review requirements for solar panels. California's Solar Rights Act limits HOAs from outright banning solar but allows them to require aesthetic considerations. Your installer should be familiar with navigating HOA submissions and can often handle the process for you.",
    },
    {
      heading: "Step 5: Permits and inspections are mandatory",
      body: "Solar installations in Arcadia require a city permit and utility interconnection approval from SCE before your system can go live. A legitimate installer handles both. The process typically takes 4–8 weeks from contract to activation, depending on permit timelines.",
    },
    {
      heading: "Ready to go solar in Arcadia?",
      body: "BuildBright helps Arcadia homeowners submit solar project requests and organize project intake through available contractors. Submit your project at buildbright.app so BuildBright can help coordinate next steps."
    },
  ],
};

export default post;
